import { AnimatedNumber } from "@/components/portfolio/AnimatedNumber";
import LoadingAnalysis from "@/components/portfolio/LoadingAnalysis";
import { useLanguage } from "@/context/LanguageContext";
import { useEstateContext } from "@/context/EstateContext";
import { HomeIcon } from "@heroicons/react/24/solid";
import type { ReactNode } from "react";
import { Panel, PanelGrid } from "@/components/ui/Panel";

const SectionBadge = ({ children }: { children: ReactNode }) => (
  <span className="app-pill-section">{children}</span>
);

export default function PossibleRent() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      rentEstimate: "Odhad nájmu",
      rentEstimateText: "Za kolik můžete pronajmout tuto nemovitost",
      currentCondition: "Aktuální stav",
      afterRenovation: "Po kompletní rekonstrukci",
      currency: "Kč",
      checking: "Zjišťujeme",
    },
    en: {
      rentEstimate: "Rent estimate",
      rentEstimateText: "How much you can rent this property for",
      currentCondition: "Current condition",
      afterRenovation: "After full renovation",
      currency: "CZK",
      checking: "Checking",
    },
  }[language];
  const { isLoadingAnalysis, analysis, isPredictionView, isGraphView } =
    useEstateContext();

  if (isGraphView) {
  } else if (!isPredictionView) {
    return null;
  }
  return (
    <Panel className="mx-auto h-full w-full max-w-3xl text-foreground">
      <div className="flex flex-col gap-1 text-center">
        <div className="flex justify-center">
          <SectionBadge>{copy.rentEstimate}</SectionBadge>
        </div>
        <div className="flex items-center justify-center gap-2">
          <HomeIcon className="size-5 text-foreground" />
          <span className="app-card-title">{copy.rentEstimateText}</span>
        </div>
      </div>

      <PanelGrid className="mt-3 grid-cols-1 text-center">
        <Panel
          variant="compact"
          className="flex flex-col items-center justify-center"
        >
          <div className="flex flex-col items-center justify-center">
            <span className="card-window__inner-eyebrow">
              {copy.currentCondition}
            </span>
            <span className="min-w-[10ch] text-xl font-bold text-foreground sm:text-2xl">
              {isLoadingAnalysis ? (
                <LoadingAnalysis isLoading={isLoadingAnalysis} />
              ) : analysis.avgPriceBefore > 0 ? (
                <>
                  <AnimatedNumber value={analysis.avgPriceBefore} />{" "}
                  {copy.currency}
                </>
              ) : (
                <>{copy.checking}</>
              )}
            </span>
          </div>
        </Panel>

        <Panel
          variant="compact"
          className="flex flex-col items-center justify-center"
        >
          <div className="flex flex-col items-center justify-center">
            <span className="card-window__inner-eyebrow">
              {copy.afterRenovation}
            </span>
            <span className="min-w-[10ch] text-xl font-bold text-foreground sm:text-2xl">
              {isLoadingAnalysis ? (
                <LoadingAnalysis isLoading={isLoadingAnalysis} />
              ) : analysis.avgPriceAfter > 0 ? (
                <>
                  <AnimatedNumber value={analysis.avgPriceAfter} />{" "}
                  {copy.currency}
                </>
              ) : (
                <>{copy.checking}</>
              )}
            </span>
          </div>
        </Panel>
      </PanelGrid>
    </Panel>
  );
}
